<template>
    <div v-if="modules.length > 0">
        <div :class="[!isPartner ? 'pt-0 mt-0 pb-4 d-block' : '']">
            <h4 class="font-weight-bold d-inline-block">
                {{ $t('resources.planProposal.attributes.optional_modules') }}
            </h4>
            <span> {{ $t('resources.planProposal.attributes.addon_label') }}</span>
        </div>
        <h5 class="pt-0 mt-0 pb-4" v-if="isPartner"> {{ $t('resources.planProposal.attributes.third_party_description') }}</h5>

        <v-row>
            <component
                v-for="(module, index) in modules"
                :is="module.price_type"
                :key="getModuleKey(module, index)"
                :module="module"
                :ref="getModuleRef(module)"
                :is-active="isModuleActiveOnCustomer(module)"
                :fixed-modules="fixedModules"
                :active-module-ids="activeModuleIds"
                @checked="$emit('checked', $event)"
                @addAmount="$emit('addAmount', $event)"
            />
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Flat from './Flat.vue'
import Unit from './Unit.vue'
import { customerRecordMatchesPackageModule } from '@/shared/utils/moduleUtils'

export default {
    name: 'ModuleSelector',

    components: {
        Flat,
        Unit,
    },

    computed: {
        ...mapGetters('reseller', ['isPartner']),
    },

    props: {
        modules: {
            type: Array,
            default: () => [],
        },

        planPackageId: {
            type: [Number, String],
            required: true,
        },

        activeModuleIds: {
            type: Array,
            default: () => [],
        },

        fixedModules: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        isModuleActiveOnCustomer(module) {
            if (module.skipActivePrefill) {
                return false
            }

            return this.activeModuleIds.some(record =>
                customerRecordMatchesPackageModule(record, module),
            )
        },

        getModuleKey(module, index) {
            // Garante chaves únicas mesmo com módulos duplicados (ex.: combos)
            const baseId =
                module.module_id ||
                (module.module && module.module.id) ||
                module.id ||
                'no-id'

            // Index do v-for entra sempre na chave para evitar duplicidade
            return `component_${this.planPackageId}_${baseId}_${index}`
        },

        getModuleRef(module) {
            return `component_${this.planPackageId}_${module.module_id}`
        },

        updateModule(module) {
            const ref = this.getModuleRef(module)
            const component = this.$refs[ref]

            if (component && component[0]) {
                component[0].update(module)
            }
        },
    },
}
</script>
